import { render, staticRenderFns } from "./AddExternalCourseware.vue?vue&type=template&id=66f6816e&scoped=true"
import script from "./AddExternalCourseware.vue?vue&type=script&lang=js"
export * from "./AddExternalCourseware.vue?vue&type=script&lang=js"
import style0 from "./AddExternalCourseware.vue?vue&type=style&index=0&id=66f6816e&prod&lang=less"
import style1 from "./AddExternalCourseware.vue?vue&type=style&index=1&id=66f6816e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6816e",
  null
  
)

export default component.exports